module.exports = __webpack_public_path__ + "img/bef3536.jpg";